import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import { SavingsSliderComponent } from './savings-slider.component';

import { NouisliderModule } from 'ng2-nouislider';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    NouisliderModule
  ],
  declarations: [SavingsSliderComponent],
  providers: [],
  bootstrap: [SavingsSliderComponent]
})
export class SavingsSliderModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/savings-slider/savings-slider.module.ts